import React from 'react';
import { IconProps } from '@/models/IconProps';

const LiveIcon: React.FC<IconProps> = ({ strokeColor }) => {
  return (
    <svg width="13" height="14" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5556 6.57213C8.07279 6.57213 8.49205 6.15286 8.49205 5.63567C8.49205 5.11848 8.07279 4.69922 7.5556 4.69922C7.03841 4.69922 6.61914 5.11848 6.61914 5.63567C6.61914 6.15286 7.03841 6.57213 7.5556 6.57213Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.55566 15.0002V6.57214"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.74634 15.0002H10.3651"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2039 8.28377C10.9061 7.58133 11.3006 6.62873 11.3006 5.63548C11.3006 4.64222 10.9061 3.68963 10.2039 2.98718"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1912 10.2709C12.7999 9.66219 13.2828 8.93952 13.6123 8.14417C13.9418 7.34881 14.1114 6.49635 14.1114 5.63545C14.1114 4.77456 13.9418 3.92209 13.6123 3.12674C13.2828 2.33138 12.7999 1.60871 12.1912 1"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.90727 8.28377C4.20504 7.58133 3.81055 6.62873 3.81055 5.63548C3.81055 4.64222 4.20504 3.68963 4.90727 2.98718"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.92021 10.2709C2.31143 9.66219 1.82852 8.93952 1.49905 8.14417C1.16958 7.34881 1 6.49635 1 5.63545C1 4.77456 1.16958 3.92209 1.49905 3.12674C1.82852 2.33138 2.31143 1.60871 2.92021 1"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LiveIcon;
